import React from 'react';
import { familyBadgeLabel, familyVersions } from '../../utils/libraryFamily';
import './LibraryVersionSwitch.css';

export function LibraryFamilyBadge({ item, className = '' }) {
  const label = familyBadgeLabel(item);
  if (!label) return null;
  return (
    <span className={`library-family-badge ${className}`.trim()} data-testid="library-family-badge">
      {label}
    </span>
  );
}

export default function LibraryVersionSwitch({ item, value, onChange }) {
  const versions = familyVersions(item);
  const options = [];
  if (versions.text) options.push({ id: 'text', label: '텍스트' });
  if (versions.image) options.push({ id: 'image', label: '이미지' });
  if (options.length < 2) return null;
  return (
    <div className="library-version-switch" data-testid="library-version-switch" role="tablist" aria-label="자료 버전">
      {options.map((option) => (
        <button
          aria-selected={value === option.id}
          className={`library-version-switch__tab${value === option.id ? ' is-active' : ''}`}
          data-testid={`library-version-tab-${option.id}`}
          key={option.id}
          onClick={() => onChange(option.id)}
          role="tab"
          type="button"
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
